module.exports = __webpack_public_path__ + "media/images/home/bg-2-7cb09454c026b3c68993a21b80528c19.png";